// import React from "react";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Layout from "../../Layout/Layout";

// export default function PageShell({ title, subtitle, actions, children }) {
//   return (
//     <main className="dashboard main" id="main">
//       <Layout />
//       <Row className="justify-center subContent">
//         <Col xs={12} md={12} className="rightSide">
//           <div className="rightSideInner PageCommonCSS accounts-page">
//             <div className="accounts-page-head">
//               <div>
//                 <h2 className="mainTitle">{title}</h2>
//                 {subtitle ? <p className="subText">{subtitle}</p> : null}
//               </div>
//               {actions ? <div className="accounts-page-actions">{actions}</div> : null}
//             </div>
//             {children}
//           </div>
//         </Col>
//       </Row>
//     </main>
//   );
// }





import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../Layout/Layout";
const LAYOUT_STYLES = [
  "/assets/vendor/bootstrap/css/bootstrap.min.css",
  "/assets/vendor/bootstrap-icons/bootstrap-icons.css",
  "/assets/css/globals.css",
  "/assets/css/style.css",
];

const isLoaded = (path) =>
  Array.from(document.styleSheets).some((sheet) => {
    try {
      return sheet.href && new URL(sheet.href).pathname === path;
    } catch (e) {
      return false;
    }
  });

let layoutPromise = null;

function ensureLayoutStyles() {
  if (!layoutPromise) {
    // prepend in reverse so the original order (bootstrap -> globals -> style)
    // is kept and accounts.css still wins where it overrides
    layoutPromise = Promise.all(
      LAYOUT_STYLES.filter((href) => !isLoaded(href))
        .reverse()
        .map(
          (href) =>
            new Promise((resolve) => {
              const link = document.createElement("link");
              link.rel = "stylesheet";
              link.href = href;
              link.setAttribute("data-accounts-layout", "true");
              link.onload = resolve;
              link.onerror = resolve;
              document.head.prepend(link);
            })
        )
    );
  }
  return layoutPromise;
}

export default function PageShell({ title, subtitle, actions, children }) {
  const [ready, setReady] = useState(() => LAYOUT_STYLES.every(isLoaded));

  useEffect(() => {
    if (ready) return undefined;
    let active = true;
    ensureLayoutStyles().then(() => active && setReady(true));
    return () => {
      active = false;
    };
  }, [ready]);

  if (!ready) return null;

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS accounts-page">
            <div className="accounts-page-head">
              <div>
                <h2 className="mainTitle">{title}</h2>
                {subtitle ? <p className="subText">{subtitle}</p> : null}
              </div>
              {actions ? <div className="accounts-page-actions">{actions}</div> : null}
            </div>
            {children}
          </div>
        </Col>
      </Row>
    </main>
  );
}